window.Highcharts = undefined;
